export const advancedSellerSearchFaq = [
    {
        title: "Does the search work in multiple Amazon marketplaces?",
        content: "Yes, our Advanced Seller Search feature allows you to search in any of 12 different Amazon marketplaces for a truly international lead generation experience."
    },
    {
        title: "Can I find sellers from specific countries operating in certain marketplaces?",
        content: "Absolutely! Advanced Seller Search enables you to target sellers from specific countries who operate in particular marketplaces, uncovering unique opportunities."
    },
    {
        title: "Is there a limit to the number of search criteria I can use?",
        content: "No, there is no limit. You can combine various search criteria, such as seller rank, category, location, and more, to refine your search and find the most relevant leads."
    },
    {
        title: "How can I integrate the seller data into my CRM?",
        content: "After exporting your search results to Excel or CSV format, you can import the data into your CRM of choice, following the CRM's specific import guidelines. This allows you to seamlessly manage and nurture your leads."
    },
    {
        title: "What kind of information can I expect to find on the sellers I discover through Advanced Seller Search?",
        content: "Our platform provides comprehensive information on Amazon sellers, including seller rank, review history, top categories, top brands, revenue estimates, and more. This helps you get a holistic view of each seller's business, enabling you to make informed decisions."
    },
    {
        title: "Are there any additional features or insights available with a subscription?",
        content: "Yes, subscribing to TrackSellers unlocks additional features and benefits, such as access to more in-depth seller metrics, Seller Leads, and the Seller Intelligence Report. These tools offer even greater insights and opportunities for lead generation and nurturing."
    }
]
